var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"atom-label",class:{
    _bold: _vm.props.bold,
    _accent: _vm.props.accent,
    _danger: _vm.props.danger,
    _white: _vm.props.white,
    _primary: _vm.props.primary,
    _extraSmall: _vm.props.extraSmall,
    _small: _vm.props.small,
    _normal:
      !_vm.props.extraSmall && !_vm.props.small && !_vm.props.large && !_vm.props.extraLarge,
    _large: _vm.props.large,
    _extraLarge: _vm.props.extraLarge
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }